import type { JournalHandoutData } from "@roll1/shared";
import { NOTE_CLASS } from "../ui/card";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";
import { useI18n } from "../../i18n";

interface HandoutFormProps {
  data: JournalHandoutData;
  onChange: (partial: Partial<JournalHandoutData>) => void;
  focusedFieldRef: React.MutableRefObject<string | null>;
}

export default function HandoutForm({
  data,
  onChange,
  focusedFieldRef,
}: HandoutFormProps) {
  const { t } = useI18n();

  const handleFocus = (field: string) => {
    focusedFieldRef.current = field;
  };
  const handleBlur = () => {
    focusedFieldRef.current = null;
  };

  return (
    <div className="space-y-3">
      <div>
        <Label className="text-meta text-muted-foreground">
          {t("journal.form.handout.content")}
        </Label>
        <Textarea
          className="text-ui min-h-[120px] font-mono"
          value={data.content}
          onChange={(e) => onChange({ content: e.target.value })}
          onFocus={() => handleFocus("content")}
          onBlur={handleBlur}
        />
      </div>
      <div>
        <Label className="text-meta text-muted-foreground">
          {t("journal.form.handout.image")}
        </Label>
        <Input
          className="h-8 text-ui"
          value={data.image ?? ""}
          onChange={(e) => onChange({ image: e.target.value })}
          onFocus={() => handleFocus("image")}
          onBlur={handleBlur}
        />
      </div>
      <div className={NOTE_CLASS}>
        <Label className="text-meta text-muted-foreground">
          {t("journal.form.handout.gmNotes")}
          <span className="ml-1 text-warn text-label">
            {t("journal.editor.gmOnly")}
          </span>
        </Label>
        <Textarea
          className="text-ui min-h-[60px]"
          value={data.gmNotes}
          onChange={(e) => onChange({ gmNotes: e.target.value })}
          onFocus={() => handleFocus("gmNotes")}
          onBlur={handleBlur}
        />
      </div>
    </div>
  );
}
